export const simpleRocket = [
  '0 0 32 32',
  `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 67 87.8" style="enable-background:new 0 0 67 87.8;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#FF5924;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FF5924;}
</style>
<path class="st0" d="M40.6,75.6c0,2.4-3.5,7.1-7.1,11c-3.3-3.5-7.1-8.5-7.1-11c0-1.9,0.7-3.7,2.1-5c1.3-1.3,3.1-2.1,5-2.1
	c1.9,0,3.7,0.7,5,2.1C39.9,71.9,40.6,73.7,40.6,75.6z"/>
<g>
	<path class="st1" d="M33.5,18.8c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S36,18.8,33.5,18.8z"/>
	<path class="st1" d="M33.5,1.6c-23,18.6-14.2,44.5-11.1,59.1c8,4,14.6,4,22.6,0C48.1,46.1,57,20.2,33.5,1.6z M35.3,53.7
		c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5V41c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5V53.7z M33.5,30.8c-4.1,0-7.5-3.4-7.5-7.5
		s3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5S37.7,30.8,33.5,30.8z"/>
</g>
<path class="st1" d="M19.2,61.3c-10.3,1-13.3,6.4-17.2,3c-4.4-4.4,4.4-18.7,12.8-28.6c0,3.9,0.5,7.4,1.5,11.3
	C17.2,51.9,18.2,56.9,19.2,61.3z"/>
<path class="st1" d="M48.2,61.5c10.4,1,13.4,6.5,16.9,3c4.5-4.5-4.5-18.9-12.4-28.8c-0.5,4-1,7.5-1.5,11.4
	C50.2,52.1,49.2,57.1,48.2,61.5z"/>
`
]
